import React from "react";
import ColorLogo from "../../assets/login/ColorLogo.png";
import DMW from "../../assets/login/DMW_Patiala.png";
import HABD from "../../assets/header/HABD.png";

function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
      <div className="container mx-auto px-4 py-2 flex flex-col sm:flex-row justify-between items-center h-auto sm:h-16">
        {/* Main Logo with Link */}
        <a
          href="https://noviusrailtech.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={ColorLogo}
            alt="Novius Logo"
            className="max-h-[40px] sm:max-h-[60px] w-auto" // Smaller on mobile
          />
        </a>

        {/* Title and HABD Logo */}
        <div className="flex items-center space-x-2">
          {/* HABD Logo */}
          <img
            src={HABD}
            alt="HABD Logo"
            className="h-8 sm:h-10 mt-2 sm:mt-0 lg:h-10 xl:h-12" // Reduced size of HABD logo
          />

          {/* Title */}
          <h1 className="text-blue-900 text-center text-xs sm:text-sm md:text-base lg:text-lg font-semibold mt-2 sm:mt-0 sm:text-left">
            NOVIUS HABD (Lite) - NOVIUS HOT AXLE BOX DETECTION SYSTEM (LITE MODEL)
          </h1>
        </div>

        {/* Placeholder Logo */}
        <img
          src={DMW}
          alt="Company Logo"
          className="h-10 sm:h-12 mt-2 sm:mt-0 lg:h-12 xl:h-16" // Smaller on mobile
        />
      </div>
    </header>
  );
}

export default Header;
